export const companyImagePathName = (
  name: string,
  uniqueID: string,
  extension: string
): string => {
  const timestamp = new Date().getTime()
  return `company/${uniqueID}-${name}_${timestamp}.${extension}`
}

export const perkImagePathName = (
  name: string,
  uniqueID: string,
  extension: string
): string => {
  const timestamp = new Date().getTime()
  return `perk/${uniqueID}-${name}_${timestamp}.${extension}`
}

export const messageImagePathName = (
  name: string,
  uniqueID: string,
  extension: string
): string => {
  const timestamp = new Date().getTime()
  return `message/${uniqueID}-${name}_${timestamp}.${extension}`
}

export const imagePathName = (
  folder: string,
  name: string,
  uniqueID: string,
  extension: string
) => {
  const timestamp = new Date().getTime()
  return `${folder}/${uniqueID}-${name}_${timestamp}.${extension}`
}
